import { cva } from 'class-variance-authority';

export const PROGRESS_FILL_TONES = ['neutral', 'theme'] as const;
export type ProgressFillTone = (typeof PROGRESS_FILL_TONES)[number];

export const PROGRESS_TRACK_TONES = ['neutral', 'theme', 'surface'] as const;
export type ProgressTrackTone = (typeof PROGRESS_TRACK_TONES)[number];

/** Text tokens the label may use; `h6` keeps the default 16px heading style. */
export const PROGRESS_LABEL_SIZES = ['h6', 'b4', 'b5', 'l1'] as const;
export type ProgressLabelSize = (typeof PROGRESS_LABEL_SIZES)[number];

/** Label font weight; `bold` keeps the default emphasis. */
export const PROGRESS_LABEL_WEIGHTS = ['bold', 'regular'] as const;
export type ProgressLabelWeight = (typeof PROGRESS_LABEL_WEIGHTS)[number];

/** Value font weight; `regular` keeps the default. */
export const PROGRESS_VALUE_WEIGHTS = ['regular', 'bold'] as const;
export type ProgressValueWeight = (typeof PROGRESS_VALUE_WEIGHTS)[number];

/** Stacked (top/bottom) label-to-bar gap, keyed by label size so it tightens as the label shrinks. */
export const PROGRESS_TOP_LABEL_GAP = {
  h6: 'md',
  b4: 'md',
  b5: 'sm',
  l1: 'xs',
} as const satisfies Record<ProgressLabelSize, 'md' | 'sm' | 'xs'>;

// The indicator is translated, not resized, so rounding it leaves value and clipping unchanged.
export const progressFillVariants = cva('[&>div]:rounded-max', {
  variants: {
    fillTone: {
      neutral: '[&>div]:!bg-black',
      theme: '[&>div]:!bg-progress-fill',
    },
  },
  defaultVariants: { fillTone: 'neutral' },
});

export const progressTrackVariants = cva('', {
  variants: {
    trackTone: {
      // Unset keeps the light-gray track; existing bars are unchanged.
      neutral: '',
      theme: '!bg-progress-track',
      // Tenant base surface token (`--surface-base`), white fallback.
      surface: '!bg-surface-base',
    },
  },
  defaultVariants: { trackTone: 'neutral' },
});
